import * as actions from './updatePasswordActions';

const updatePasswordReducers = {
  [actions.USER_UPDATE_PASSWORD_SUCCESS_RECEIVED]: (state, { payload }) => {
    state.profile.lastPasswordUpdateDate = payload.data.lastPasswordUpdateDate;
    return state;
  },
};

export default updatePasswordReducers;
